import React from "react";
import { Input } from "antd";
import classNames from "classnames";
import { NumericFormat, NumberFormatBaseProps } from "react-number-format";

const CurrencyInput = React.forwardRef<any, any>((props, ref) => {
  return <Input {...props} prefix="$" ref={ref} />;
});
CurrencyInput.displayName = "CurrencyInput";

export const Currency: React.FunctionComponent<NumberFormatBaseProps> = (
  props: NumberFormatBaseProps
) => {
  const { className, ...restProps } = props;
  return (
    <NumericFormat
      customInput={CurrencyInput}
      type="tel"
      autoComplete="off"
      displayType="input"
      allowNegative={false}
      thousandSeparator=","
      decimalSeparator="."
      decimalScale={2}
      className={classNames("ant-input", className)}
      {...restProps}
    />
  );
};
